<template functional>
  <!-- A simple pop-over component using a Bootstrap theme. -->
  <VDropdown
    :triggers="data.attrs.triggers || ['hover', 'focus']"
    theme="bs-popover"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <slot name="reference"></slot>

    <template #popper>
      <div class="card popper-content">
        <div class="card-body">
          <h5 v-if="props.title" class="card-title">
            {{ props.title }}
          </h5>
          <div class="card-text">
            <slot></slot>
          </div>
        </div>
      </div>
    </template>
  </VDropdown>
</template>

<script>
import Vue from 'vue';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip, {
  themes: {
    'bs-popover': {
      $extend: 'dropdown'
    }
  }
});

export default {
  name: 'pop-over',

  props: {
    title: String
  }
};
</script>

<style lang="scss">
@use "v-tooltip/dist/v-tooltip";

.v-popper--theme-bs-popover {
  &.v-popper__popper {
    z-index: 3000000;
  }

  .v-popper__inner {
    padding: 0;
  }

  .popper-content {
    max-width: 500px;
  }
}
</style>
